import PropTypes from 'prop-types';

import {
  DOCTOR,
  PATIENT,
  RESEARCHER,
  TECHNICIAN,
  SUPER_RESEARCHER,
  SUPER_TECHNICIAN,
} from 'constants/userRoles';

export const UserRoleType = PropTypes.oneOf([
  DOCTOR,
  PATIENT,
  RESEARCHER,
  TECHNICIAN,
  SUPER_RESEARCHER,
  SUPER_TECHNICIAN,
]);
